//
import Model from "@/models/Model"

/**
 * 
 */
export default class ARawQuery extends Model {

    /**
     * @description
     */
    resource () {
        return "raw_query"
    }
}